import dataSources from 'dataSources';
import Promise from 'core-js-pure/actual/promise';
import {
  FilterParams as InitStationsFilterParams,
  Result as InitStationsResult,
} from './types/initStations';
import { IStationsResponse } from 'dataSources/Typicode/stations';

export const initStations = async ({
  urlFilter,
  fullCardNumber,
}: {
  urlFilter?: InitStationsFilterParams;
  fullCardNumber: string;
}) => {
  const filterKeys = Object.keys(urlFilter || {});
  const filterValues = Object.values(urlFilter || {}).filter(Boolean);

  const filterKeysHasOnlyFullCardNumber =
    filterKeys.length === 1 &&
    filterKeys[0] === 'fullCardNumber' &&
    filterKeys.pop();

  const [allStations, stationCodes] = await Promise.allSettled([
    dataSources.stations.getStations(
      fullCardNumber ? { fullCardNumber } : {},
    ) as Promise<IStationsResponse>,
    !filterKeysHasOnlyFullCardNumber && filterValues.length
      ? dataSources.stations.getStationCodes(urlFilter!)
      : undefined,
  ]);

  return [allStations, stationCodes] as InitStationsResult;
};
